module.exports = __webpack_public_path__ + "static/media/raygun.c0994421.svg";